const fixDataFuncMap = {
  // '27': (item) => {
  //   const inputDom = document.getElementById('home-key-search');
  //   if (inputDom) {
  //     item.custom = inputDom.value;
  //   }
  // },
  'custom-id': (item) => {
    const triggerPageUrl = item.triggerPageUrl
    if (triggerPageUrl.includes('/trade-center')) {
      item.eventId = '15'
      return
    }
    if (triggerPageUrl.includes('/data-company')) {
      item.eventId = '16'
      return
    }
    if (triggerPageUrl.includes('/market')) {
      item.eventId = '17'
      return
    }
    item._finalAdd = false;
  }
};

const clickFix = (item: any) => {
  if (item.params?.custom) {
    item.custom = item.params.custom
  }
  if (fixDataFuncMap[item.eventId]) {
    fixDataFuncMap[item.eventId](item);
  }
  delete item.params;
  delete item.elementPath;
  if (item._finalAdd !== false) {
    item._finalAdd = true;
  }
  return item;
};

export default clickFix;
